"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query venue($venueId: String) {
    venue(venueId: $venueId) {
      _id
      orgId
      name
      description
      capacity
      address {
        address1
        address2
        city
        state
        zip
        country
        phone
        lat
        lng
        placeId
        placeName
        timezone
      }
      tax
      url
      imageUrls
      venueGlobalId
    }
  }
`;
exports.default = query;
//# sourceMappingURL=venue.query.js.map